import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const testimonials = [
  {
    name: 'M.S. 様',
    age: '40代 女性',
    text: 'あんなに辛かっためまいが、数回の施術で嘘のように消えました！病院では「原因不明」と言われ諦めかけていたので、本当に感謝しています。',
  },
  {
    name: 'K.T. 様',
    age: '30代 女性',
    text: '病院で原因不明と言われ諦めていましたが、先生に出会えて救われました。優しい施術で安心でき、今では外出も怖くなくなりました。',
  },
  {
    name: 'A.Y. 様',
    age: '50代 女性',
    text: '久しぶりに朝までぐっすり眠れて、毎日が楽しくなりました。体が軽くなったのを実感しています。家族にも元気な顔を見せられます。',
  },
];

const cardDelays = ['delay-2', 'delay-3', 'delay-4'];

export default function TestimonialsSection() {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section id="voice" className="bg-clinic-cream-dark py-16 md:py-24">
      <div ref={ref} className={`w-full px-4 md:px-8 max-w-5xl mx-auto scroll-reveal ${isVisible ? 'visible' : ''}`}>
        <h2 className="font-serif text-xl md:text-3xl font-bold text-clinic-dark text-center mb-3 scroll-reveal-item delay-1">
          患者様の声
        </h2>
        <p className="text-clinic-gray text-sm md:text-base text-center mb-10 md:mb-14 scroll-reveal-item delay-1">
          信頼の証。実際に施術を受けた患者様からのお声です
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {testimonials.map((t, index) => (
            <div key={index} className={`bg-white rounded-xl p-5 md:p-6 shadow-sm scroll-reveal-item ${cardDelays[index]}`}>
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full bg-clinic-green-light flex items-center justify-center">
                  <i className="ri-user-3-line text-clinic-green" />
                </div>
                <div>
                  <p className="font-bold text-clinic-dark text-sm">{t.name}</p>
                  <p className="text-clinic-gray text-xs">{t.age}</p>
                </div>
              </div>
              <p className="text-clinic-dark text-sm leading-relaxed">
                「{t.text}」
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}